import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Router, NavigationStart } from '@angular/router';
import { Observable } from 'rxjs';
import { UserTypeIDEnum } from 'src/app/helpers/enum';
import { LoginUsersStore } from 'src/app/login-users.store';
import { UserResponse } from 'projects/nfrp-mas-retail-private-angular/src/nfrp-mas-retail/model/login-response';
import { CommunicationService } from 'src/app/services/communication.service';
import { LoginService } from 'src/app/services/login.service';

@Component({
    selector: 'mas-retail-header',
    templateUrl: './mas-retail-header.component.html',
    standalone: false
})
export class MasRetailHeaderComponent implements OnInit {
  planId: string;
  userResponse$: Observable<UserResponse[]> = this.loginUsersStore.userResponse$;

  searchPlanForm: UntypedFormGroup = this.fb.group({
    searchQuery: [null],
  });
  searchQuery: string;
  userTypeId: number;
  login = false;
  isHideSearchBox = false;
  isPrivacyPolicy = false;

  constructor(
    private fb: UntypedFormBuilder,
    private loginUsersStore: LoginUsersStore,
    private loginService: LoginService,
    private communicationService: CommunicationService,
    private router: Router
  ) {
    const loginUser = sessionStorage.getItem('loginUser');
    this.userTypeId = loginUser ? JSON.parse(loginUser)?.userTypeId : 0;
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
        if (
          event.url === '/login' ||
          event.url === '/' ||
          event.url === '/reset-password' ||
          event.url === '/reset-password-info' || 
          event.url === '/forgot-password' ||
          event.url === '/forgot-password-link' ||
          (event.url === '/privacy-policy' && this.userTypeId === 0)
        ) {
          this.login = false;
        } else {
          this.setSearchBoxVisability()
          this.login = true;
        }
      }
    });
    this.communicationService.userLoggedInStatusEvent.subscribe(() => {
      this.setSearchBoxVisability();
    });
  }

  ngOnInit() {
    window.scroll(0, 0);
    this.setSearchBoxVisability();
  }

  setSearchBoxVisability(): void{
    const loginUser = sessionStorage.getItem('loginUser');
    this.userTypeId = loginUser ? JSON.parse(loginUser)?.userTypeId : 0;
    if (
      this.userTypeId === UserTypeIDEnum.CALL_CENTER ||
      this.userTypeId === UserTypeIDEnum.ENROLLMENT_KIT_PROCESSOR ||
      this.userTypeId === UserTypeIDEnum.PUBLIC_MONEY_MANAGER ||
      this.userTypeId === 0
    ) {
      this.isHideSearchBox = true;
    } else {
      this.isHideSearchBox = false;
    }
  }
  
  onSearchPlanSubmit(): void {
    this.searchQuery = this.searchPlanForm.get('searchQuery').value ? this.searchPlanForm.get('searchQuery').value: '';
    this.changePlanSearchView(this.searchQuery);
  }

  changePlanSearchView(searchStr: string) {
    this.router.navigate(['/home', searchStr]);
    this.searchPlanForm.reset();
  }
  navigateToHome() {
    this.searchPlanForm.reset();
    this.communicationService.userLoggedInStatus(false);
    this.userTypeId = 0;
    const loginUser = sessionStorage.getItem('loginUser');
    
    let userId = 0;
    let refNum = '';
    
    try {
      if (loginUser) {
        const parsedUser = JSON.parse(loginUser);
        userId = parsedUser?.userId || 0;
        refNum = parsedUser?.refNum || '';
      }
    } catch (error) {
      // Handle error silently
    }
    
    sessionStorage.removeItem('loginUser');
    this.loginService.logOutUser(userId, false, refNum).subscribe({
      error: () => {
        // Handle error silently
      }
    });
    this.router.navigate(['/login']);
  }
  navigateLoginOrHome() {
    if(sessionStorage.getItem('passwordExpired') === 'true') {
      this.router.navigate(['/login']);
    } 
    else if (this.userTypeId === UserTypeIDEnum.CALL_CENTER){
      this.router.navigate(['/cc-home']);
    }
    else if (this.userTypeId === UserTypeIDEnum.PUBLIC_MONEY_MANAGER) {
      this.router.navigate(['/plan-fund-adv']);
    }
    else if (this.userTypeId === UserTypeIDEnum.ENROLLMENT_KIT_PROCESSOR) {
      this.router.navigate(['/ekp-home']);
    }
    else {
      this.router.navigate(['/home']);
    }
  }
}
